export default __webpack_public_path__ + "static/media/temporarybarrier.d68b323e.png";